import { Injectable, inject, NgZone } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class KeyboardService {
  private readonly router = inject(Router);
  private readonly zone = inject(NgZone);
  private enabled = true;

  init(): void {
    document.addEventListener('keydown', (e: KeyboardEvent) => {
      // Don't intercept when typing in inputs/textareas
      const target = e.target as HTMLElement;
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return;
      if (!this.enabled) return;

      // Check if we're on a customer page
      const url = this.router.url;
      const customerMatch = url.match(/^\/(\d+)/);
      if (!customerMatch) return;

      const customerId = customerMatch[1];

      this.zone.run(() => {
        switch (e.key) {
          case '1': this.router.navigate([customerId, 'information']); break;
          case '2': this.router.navigate([customerId, 'contracts']); break;
          case '3': this.router.navigate([customerId, 'invoice']); break;
          case '4': this.router.navigate([customerId, 'tariffcheck']); break;
        }
      });
    });
  }

  disable(): void { this.enabled = false; }
  enable(): void { this.enabled = true; }
}
